// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function LinkBoldIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="M17.046 23.441a1.5 1.5 0 0 1 0 2.125l-.742.743a7.503 7.503 0 0 1-10.61-10.61l3.015-3.014A7.5 7.5 0 0 1 19 12.375a1.506 1.506 0 0 1-2 2.25 4.5 4.5 0 0 0-6.171.184l-3.013 3.01a4.5 4.5 0 1 0 6.365 6.365l.743-.743a1.5 1.5 0 0 1 2.122 0Zm9.26-17.75a7.511 7.511 0 0 0-10.61 0l-.742.743a1.503 1.503 0 1 0 2.125 2.125l.742-.743a4.5 4.5 0 0 1 6.365 6.365l-3.014 3.015a4.5 4.5 0 0 1-6.172.179 1.504 1.504 0 0 0-2.354 1.782c.086.177.206.337.354.468a7.5 7.5 0 0 0 10.288-.304l3.014-3.014a7.511 7.511 0 0 0 .004-10.613V5.69Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
